import type { DocMigration } from "../docMigration";
import { migrateModelToExtendDocEntityBase } from "../docMigrationUtils";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_64: DocMigration = {
  maxSchemaVersion: "0.0.64",
  description: "Refactor Sheet to implement DocEntityBase",
  apply(json: any) {
    if (json.sheets) {
      migrateModelToExtendDocEntityBase(json, "sheets");
    }
    return json;
  },
};

export default migration_0_0_64;
